import React from 'react'
import ReactPaginate from 'react-paginate'
import "./OPagination.css"

const OPagination = ({ pageCount, handlePageClick, page }) => {
  if (pageCount > 1) {
    return (
      <div className='react-paginate-class d-flex justify-content-center mt-4'>
        <ReactPaginate
          previousLabel='<'
          nextLabel='>'
          breakLabel='...'
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          containerClassName='pagination'
          subContainerClassName='pages pagination'
          activeClassName='active'
          breakClassName='page-item'
          breakLinkClassName='page-link'
          pageClassName='page-item'
          pageLinkClassName='page-link'
          previousClassName='page-item'
          previousLinkClassName='page-link'
          nextClassName='page-item'
          nextLinkClassName='page-link'
          forcePage={page - 1}
          nextIconButtonProps={{ disabled: true }}
          backIconButtonProps={{ disabled: true }}
        />
      </div>
    )
  }
}

export default OPagination
